export enum ClubType {
  OFFICIAL = 'OFFICIAL',
  HOBBY = 'HOBBY',
}
